var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.908325 8.26927L0.908258 8.26925C0.908366 4.07763 4.53151 0.698297 8.98035 0.698297C13.4292 0.698297 17.0524 4.07786 17.0524 8.26944C17.0524 9.59731 16.4668 11.3459 15.2884 13.5396C14.1106 15.7321 12.3434 18.3643 9.98662 21.4578C9.56305 22.0135 8.76929 22.1208 8.21354 21.6973C8.1234 21.6285 8.04293 21.548 7.97415 21.4577L7.93914 21.4843L7.97414 21.4577C5.61737 18.3641 3.8502 15.732 2.67241 13.5395C1.49398 11.3458 0.908325 9.59723 0.908325 8.26927ZM8.94526 20.2846L8.98035 20.3309L9.01543 20.2846C11.1986 17.4007 12.8363 14.9447 13.9285 12.9371C15.0196 10.9314 15.5695 9.3674 15.5695 8.26944C15.5695 4.91699 12.6282 2.18154 8.98035 2.18154C5.33248 2.18154 2.39114 4.91708 2.39114 8.26944C2.39114 9.36725 2.94103 10.9312 4.03219 12.937C5.1243 14.9446 6.76202 17.4007 8.94526 20.2846Z",
    fill: "#484848",
    stroke: "white",
    strokeWidth: 0.0880001
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98067 11.8195C7.12517 11.8195 5.62115 10.3149 5.62115 8.45899C5.62115 6.60322 7.12517 5.09869 8.98067 5.09869C10.8362 5.09869 12.3402 6.60322 12.3402 8.45899C12.3402 10.3149 10.8362 11.8195 8.98067 11.8195ZM8.98067 10.3362C10.0171 10.3362 10.8573 9.49583 10.8573 8.45899C10.8573 7.42232 10.0171 6.58193 8.98067 6.58193C7.94422 6.58193 7.10403 7.42232 7.10403 8.45899C7.10403 9.49583 7.94422 10.3362 8.98067 10.3362Z",
    fill: "#484848",
    stroke: "white",
    strokeWidth: 0.0880001
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c046af2de7f8e5171b04f82a54737089.svg";
export { ForwardRef as ReactComponent };